
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/g/pages",
      function () {
        return require("private-next-pages/g/pages/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/g/pages"])
      });
    }
  